import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactSVG } from "react-svg";
import { Image, Popup } from "semantic-ui-react";
import imageRegistry from "../../constants/imageRegistry";
import { extractSubstring, scrollToTop } from "../../helpers/common";
import { formatNumber } from "../../helpers/formatter";
import UnknownVinDialog from "../section2/UnknownVinDialog";

export const style = {
  borderRadius: "10px",
  background: "#292F36",
  color: "#FFFFFF",
};

const AccountCar = ({ vehicle, isClickable, handleCardClick, isLoading }) => {
  const {
    image_url_full: imageUrl,
    vin,
    miles,
    name_of_vehicle: vehicleCardNumber,
    license_plate_number: licensePlateNumber,
    vehicle_name: vehicleName,
    fleetcor_enrolled: fleetcorEnrolled,
  } = vehicle || {};

  const { t } = useTranslation("accountCar");
  const [openUnknownVinDialog, setOpenUnknownVinDialog] = useState(false);

  const handleUnknownVinDialog = () => {
    setOpenUnknownVinDialog((prev) => !prev);
  };

  return (
    <div className={`account__car ${isLoading && "vehicle__account-opacity"}`}>
      <Image
        className="car-image"
        src={imageUrl || imageRegistry.carPlaceholderLogo}
      />
      <div className="vehicle__details-container">
        <p className="vehicle__details-YMM">
          <>
            <span className="text__truncate">
              {fleetcorEnrolled
                ? vehicleName || vehicleCardNumber || t("vehicleUnknown")
                : vehicleCardNumber}
            </span>
            <Popup
              trigger={
                <ReactSVG wrapper="span" src={imageRegistry.GrayInfoLogo} />
              }
              className="popup__info"
              style={style}
              content={
                <p>
                  <span>
                    {t("gasCardName")}
                    {fleetcorEnrolled && ":"}
                  </span>
                  {fleetcorEnrolled && <p>{vehicleCardNumber}</p>}
                </p>
              }
              disabled={!vehicleName && !vehicleCardNumber}
              on="click"
              hideOnScroll
              position="top center"
            />
          </>
        </p>
        <p className="vehicle__details-vin">
          <span className="text__truncate">
            {t("vin")} {vin || t("unknown")}
          </span>
          {!vin && (
            <ReactSVG
              wrapper="span"
              onClick={handleUnknownVinDialog}
              src={imageRegistry.questionLogo}
            />
          )}
        </p>
        {licensePlateNumber && (
          <p className="vehicle__details-vin">
            <span className="text__truncate">
              {t("licensePlate")}: {licensePlateNumber}
            </span>
          </p>
        )}
      </div>
      <div className="vehicle__mileage">
        {fleetcorEnrolled && (
          <p className="vehicle__details-card">
            ***{vehicleCardNumber && extractSubstring(vehicleCardNumber, 4)}
          </p>
        )}
        <p className={`${miles ? "no__mileage" : "vehicle__details-mileage"}`}>
          {miles ? `${formatNumber(miles)} Mi` : t("noMileage")}
        </p>
      </div>
      {isClickable && (
        <div
          className="right__arrow"
          onClick={() => {
            scrollToTop();
            handleCardClick(vehicle);
          }}
        >
          <ReactSVG src={imageRegistry.verticalLineLogo} />
          <ReactSVG
            className="right__arrow-svg cursor__pointer"
            src={imageRegistry.rightArrow}
          />
        </div>
      )}
      {openUnknownVinDialog && (
        <UnknownVinDialog
          open={openUnknownVinDialog}
          handleClose={handleUnknownVinDialog}
          handleOpen={handleUnknownVinDialog}
        />
      )}
    </div>
  );
};

export default AccountCar;
